export default __webpack_public_path__ + "static/media/cardIcon.fa2bf8d6.svg";